
export const api = {
    host:  process.env.REACT_APP_API_URL,
    // hostOld:  'https://api.honee.ai/',
    // host: 'http://api.launchpad.adtdev.pro/',
    news:{
        latest: 'api/v1/posts/latest',
        post: 'api/v1/posts',
        top: 'api/v1/posts/latest?top=1',
        paginate: 'api/v1/posts/paginated',
    },
    cabinet: {
        user: 'api/v1/user',
        statuses: 'api/v1/statuses',
        projectsAll: 'api/v1/projects',
        setUserName: 'api/v1/set-name',
        disconnect: 'api/v1/logout',
        userProjects: 'api/v1/user/projects',
        freezeData: 'api/v1/freeze-token-periods',
        freezeWH: 'api/v1/freeze/open/via-honee',
        freezeHistory: 'api/v1/freeze/history',
        freezeExtend: 'api/v1/freeze',
        joinProject: 'api/v1/user/projects',
        launchpadMain: 'api/v1/main',
        honeeInvest: 'api/v1/allocation',
        qrInvest: 'api/v1/allocation/transaction-details',
        userAllocation: 'api/v1/user/projects/allocations',
        checkAcademy: 'api/v1/user/sync',
        wtCheck: 'api/v1/freeze/open/via-internal-wallet'
    },
    authorization: {
        getNonce: 'api/v1/login/get-nonce',
        login: 'api/v1/login',
        loginWH: 'api/v1/login/honee'
    },
    settings: {
        setName: 'api/v1/user/settings/username',
        setAvatar: 'api/v1/user/settings/avatar',
        setEmail: 'api/v1/user/settings/email',
        resendCode: 'api/v1/user/settings/email/resend',
        verifyEmail: 'api/v1/user/settings/email/verify',
        addedWallets: 'api/v1/user/settings/wallets',
        getNetworks: 'api/v1/blockchains/available',
        addWallet: 'api/v1/user/settings/wallets'
    },
    public: {
        idoForm: 'api/v1/ido-application-form',
    }
}